import { z } from 'zod';
import { PartnerMaterialFileFormatSchema } from '../../entities/partner-material/partner-material.schema';
/**
 * Request Partner Material Upload Request
 * POST /api/v2/admin/partner-materials/:id/files/:locale/upload-url
 *
 * The presigned POST pins the content type, so the format is chosen up front.
 */ export const RequestPartnerMaterialUploadRequestSchema = z.object({
    format: PartnerMaterialFileFormatSchema
});
/**
 * Request Partner Material Upload Response
 * POST /api/v2/admin/partner-materials/:id/files/:locale/upload-url
 */ export const RequestPartnerMaterialUploadResponseSchema = z.object({
    url: z.string(),
    fields: z.record(z.string(), z.string()),
    key: z.string()
});

//# sourceMappingURL=request-partner-material-upload.schema.js.map